// bootstrap import
// import "bootstrap"

import Loader from './parts/Loader.js'
import Navigation from './parts/Navigation.js'
import Smooth from './parts/Smooth.js'
// import Accordion from './parts/Accordion.js'
// import MouseStalker from './parts/MouseStalker.js'

/* @ts-ignore */
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

import { gsap } from 'gsap'
import { ScrollSmoother } from 'gsap/ScrollSmoother'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// スムーススクロール実装
//----------------------------------------------------
gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

// ----------------------------------------------------
// ナビゲーション
// ----------------------------------------------------
new Navigation({
  navId: 'site_navigation', // 対象となるnavタグのID
  humId: 'hum_toggle', // ハンバーガーメニューのID
  linkSelector: '#site_navigation a', // 対象となるaタグのセレクタ
  breakPoint: 1025, // PCとSPのブレイクポイント
  pcNavigation: true, // PCでもナビゲーションを使用する場合はtrue
})

// ----------------------------------------------------
// ローダー
// ----------------------------------------------------
new Loader({
  endFn: () => {
    console.log('load end')
  },
})

// ----------------------------------------------------
// 内部リンク
// ----------------------------------------------------
new Smooth({
  linkTarget: '.nav_link a[href*="#"]',
  breakPoint: 768, // px
  pcWaitTime: 500, // ms
  spWaitTime: 500, // ms
  exceptionId: ['exceptionId'], // 例外用のID
  exceptionFn: (id) => {
    // 例外処理
  },
})

// ----------------------------------------------------
// Top Page Banner
// ----------------------------------------------------
new Swiper('.fBanner_slide-container', {
  loop: true,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  autoplay: {
    delay: 5000,
  },
  speed: 800,
  centeredSlides: true,
  slidesPerView: 1.5,
  breakpoints: {
    500: {
      spaceBetween: 20,
      slidesPerView: 1.8,
    },
    768: {
      spaceBetween: 20,
      slidesPerView: 2.5,
    },
    1025: {
      spaceBetween: 30,
      slidesPerView: 3.5,
    },
    1366: {
      spaceBetween: 30,
      slidesPerView: 5.5,
    },
  },
})

// ----------------------------------------------------
// アコーディオンメニュー
// ----------------------------------------------------
// const navAccordionList = gsap.utils.toArray<HTMLElement>('.sp_nav-li-ac')
// if (navAccordionList.length) {
//   new Accordion(navAccordionList, {
//     toggleBtnClass: 'ac_toggle-btn',
//     itemClass: 'ac_item',
//     firstDisplay: false,
//     onlyDisplay: false,
//     onChange: (elm: HTMLElement, value: boolean, i: number) => {
//       const btn = gsap.utils.toArray<HTMLElement>('.sp_nav-acBtn', elm)
//       if (value) {
//         btn.forEach((elm) => {
//           elm.classList.add('active')
//         })
//       } else {
//         btn.forEach((elm) => {
//           elm.classList.remove('active')
//         })
//       }
//     }
//   })
// }

// ----------------------------------------------------
// マウスストーカー
// ----------------------------------------------------
// new MouseStalker({
//   stalkerClassName: 'mouse_stalker',
//   hoverClass: 'mouse_stalker-link',
//   scrub: 0.07
// })

// ----------------------------------------------------
// スムーススクロール
// ----------------------------------------------------
// document.addEventListener('DOMContentLoaded', () => {
//   setTimeout(() => {
//     let smoothFlag = false
//     let scroller
//     function createSmooth() {
//       scroller = ScrollSmoother.create({
//         smooth: 1.5,
//         effects: true,
//         smoothTouch: 0.1
//       })
//       smoothFlag = true
//     }
//     if (window.innerWidth >= 768) {
//       createSmooth()
//     }
//     window.addEventListener('resize', () => {
//       if (
//         !smoothFlag &&
//         window.innerWidth >= 768 &&
//         location.pathname !== '/'
//       ) {
//         location.reload()
//       } else if (
//         smoothFlag &&
//         window.innerWidth < 768 &&
//         location.pathname !== '/'
//       ) {
//         location.reload()
//       }
//     })
//   }, 250)
// })
